module.exports = __webpack_public_path__ + "static/media/ClementePDae-Light.59327283.ttf";